export const getUiBridge = () => window.ReactGwtBridge;


export const refreshPedigreeSubtextAndSymbols = () => {
    const bridge = getUiBridge();
    if (bridge && typeof bridge.refreshPedigreeSubtextAndSymbols === 'function') {
        bridge.refreshPedigreeSubtextAndSymbols();
    }
};

export const executeUI = (moduleName, actionType, ...args) => {
    return getUiBridge().onBtnClicked(moduleName, actionType, ...args);
};

export const updateCurrentTabTitle = (title) => {
    if (getUiBridge() && getUiBridge().updateCurrentTabTitle) {
        getUiBridge().updateCurrentTabTitle(title);
    }
};

export const updateCurrentDatasheetTab = (formatId, context, title) => {
    if (getUiBridge() && getUiBridge().updateCurrentDatasheetTab) {
        getUiBridge().updateCurrentDatasheetTab(String(formatId), String(context), title);
    }
};

export const closeCurrentTab = () => {
    if (getUiBridge() && getUiBridge().closeCurrentTab) {
        getUiBridge().closeCurrentTab();
    }
};